import React from 'react';

import { NavLink } from 'react-router-dom';
import MyPage from "../../../src/MyPage";
import SubTabsParameters from "../../../src/SubTabsParameters";

import '../../App.css';
import '../../styles.css';
  function Parameters() {
    return (
      <div className="scrollable-container">
        <MyPage />
        <SubTabsParameters />
      </div>
    );
  }
export default Parameters;